import React from 'react'

import DailyRental from './DailyRental'
import DFilter from './DFilter'


function DailyRentalComponent() {
  return (
    <>
      <h1 className="text-3xl font-semibold text-center text-[#FF9630] my-4">Daily Rentals</h1>
 
    <div className="min-h-screen flex gap-8 p-12">

    {/* Left Side - Filter (1/3 width) */}
    <div className="w-1/4">
      <DFilter/>
    </div>

    <div className="w-3/4">
  <DailyRental/>
    </div>
  </div>
  </>
  )
}; 

export default DailyRentalComponent